<template>
  <BModalConfirm
    ref="modal"
    v-bind="$attrs"
    :title-text="titleText"
    cancel-btn="Отменить"
    :success-btn="active ? 'Изменить' : 'Добавить'"
    @submit="onSubmit"
    @closed="$emit('closed')"
  >
    <v-row dense>
      <v-col cols="12">
        <BTextField
          v-model="form.href"
          label="Ссылка"
          autofocus
        />
      </v-col>

      <v-col v-if="!active && !hasSelection" cols="12">
        <BTextField
          v-model="form.text"
          validate="required"
          label="Текст ссылки"
        />
      </v-col>

      <template v-if="isFileLink">
        <v-col cols="12">
          <v-checkbox
            v-model="downloadAsIs"
            label="Скачивать файл по названию ссылки"
            dense
            hide-details
          />
        </v-col>
        <v-col v-if="!downloadAsIs" cols="12">
          <BTextField
            v-model="form.download"
            validate="required"
            label="Название файла"
          />
        </v-col>
      </template>
    </v-row>

    <template #footer-before>
      <BEditorFileUpload
        :tag="$options.tag"
        emit-full
        @input="onUpload"
      />
    </template>
  </BModalConfirm>
</template>

<script>
import { FILE_TAG_LINK } from '@/helpers/enums/params'
import { SETTINGS } from './utils'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BEditorFileUpload from './BEditorFileUpload.vue'


const createDefaultData = ({ href, text, download }) => ({
  href,
  text,
  download,
  target: '_blank',
})

const EXTENSIONS = ['doc', 'docx', 'pdf', 'xlsx', 'xls', 'zip', '7z']

export default {
  name: 'BEditorModalLink',
  $_veeValidate: {
    /** @type 'new' */
    validator: 'new',
  },
  components: {
    BModalConfirm,
    BTextField,
    BEditorFileUpload,
  },
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
      required: true,
    },
    hasSelection: {
      type: Boolean,
      required: true,
    },
    href: String,
    text: String,
    download: String,
  },
  tag: FILE_TAG_LINK,
  data: (vm) => ({
    form: createDefaultData(vm),
    downloadAsIs: !vm.download || vm.download === vm.text,
  }),
  computed: {
    titleText() {
      return this.active ? SETTINGS.link[2] : SETTINGS.link[1]
    },
    isFileLink() {
      return this.form.href?.includes('uploads/')
    },
  },
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close(flag) {
      return this.$refs.modal.close(flag)
    },
    onUpload(file) {
      const href = file?.raw_file?.url
      const text = file?.name
      const { target } = this.form
      this.form = {
        href, text, target, download: text,
      }
    },
    async onSubmit() {
      const result = await this.$validator.validate()
      if (!result) return
      const { form, isFileLink } = this
      const { download, href } = form
      const isExtUnresolved = !download || EXTENSIONS.every((ext) => !download.includes(ext))
      if (isFileLink && isExtUnresolved) {
        this.form.download = !download ? this.getFileNameFromHref(href) : this.getFileNameFromDownload(href, download)
      }

      this.close(form)
    },
    getFileNameFromHref(href) {
      // eslint-disable-next-line no-restricted-syntax
      for (const ext of EXTENSIONS) {
        if (href.includes(`-${ext}`)) {
          return href.replace(`-${ext}`, `.${ext}`)
        }
      }
      return ''
    },
    getFileNameFromDownload(href, prefilled) {
      // eslint-disable-next-line no-restricted-syntax
      for (const ext of EXTENSIONS) {
        if (href.includes(`-${ext}`)) {
          return [prefilled, ext].join('.')
        }
      }
      return prefilled
    },
  },
}
</script>
